<template>
  <div class='swhz_con'>
    <div class='pub_top_block w_1200 business_top_block'>
      <dl>
        <dt>
          <h3 v-html='$t("business.title")'></h3>
          <div class='text' v-html='$t("business.desc")'></div>
        </dt>
        <dd>
          <div class='more more2' @click='jumpCooperate'>{{ $t('business.button') }}</div>
        </dd>
      </dl>
      <img src='@/assets/img/photo_business@2x.png' alt='' class='bg' width='536' height='536'>
    </div>
    <div id='cooperate' class='block2 bg_f5'>
      <div class='w_1200'>
        <div class='pub_tit'>{{ $t('business.ways.title') }}</div>
        <ul class='fz_0'>
          <li v-for='(item, index) in list' :key='index'>
            <div class='img_box'><img :src='item.image' alt=''></div>
            <h3>{{ item.title }}</h3>
            <a href='javascript:void(0)' class='contact_btn' @click='showThisContrantWaay(item.type)'>{{ $t('business.ways.getContact') }}</a>
          </li>
        </ul>
      </div>
    </div>
    <!-- 子底部模块 -->
    <pub-bottom />
    <!-- 二维码 -->
    <cooperate-q-r-code :show='showDialog' :show-contract-info='showContractInfo' @close='closeThisDialog'></cooperate-q-r-code>
  </div>
</template>

<script>
import { setTitle } from 'utils'
import qycg from '@/assets/img/qycg.png'
import xmt from '@/assets/img/xmt.png'
import yujiaojiao from '@/assets/img/yujiaojiao.png'
import kdkQrcode from '@/assets/img/kdk_qrcode.jpg'
import xxjghzQrcode from '@/assets/img/xxjghz_qrcode.jpg'
import CooperateQRCode from '@/components/CooperateQRCode'
import PubBottom from '@/components/PubBottom'
import { listHandler } from '@/utils/variable'

export default {
  name: 'BusinessCooperate',
  components: { CooperateQRCode, PubBottom },
  data () {
    return {
      showDialog: false,
      contactWayMap: {
        qycg: { title: '企业采购合作', contractPerson: 'Amy Gong', phone: '18127000726', wechat: '18127000726', email: 'amy@hbtown.com', imgurl: qycg },
        xmthz: { title: '新媒体合作', contractPerson: 'Gino Lim', phone: '17727581674', wechat: '17727581674', email: 'gino720@dingtalk.com', imgurl: xmt },
        fxhz: { title: '分销合作', contractPerson: 'Gino Lim', phone: '17727581674', wechat: '17727581674', email: 'gino720@dingtalk.com', imgurl: xmt },
        schz: { title: '市场合作', contractPerson: 'Ellen Yu', phone: '18926070803', wechat: '18926070803', email: '657394519@qq.com', imgurl: yujiaojiao },
        xxjghz: { title: '线下机构合作', contractPerson: 'Doreen', phone: '18138415179', wechat: '18138415179', email: '785322463@qq.com', imgurl: xxjghzQrcode },
        jxjghz: { title: '教学机构合作', contractPerson: 'Doreen', phone: '18138415179', wechat: '18138415179', email: '785322463@qq.com', imgurl: kdkQrcode },
      },
      showContractInfo: {},
      title: '',
    }
  },
  computed: {
    list () {
      // 不根据语言版切换弹框值
      Object.keys(this.contactWayMap).map((item, index) => {
        this.$set(this.contactWayMap, item, {
          ...this.contactWayMap[item],
          title: this.$t('business.ways.list')[index].title,
        })
      })
      // 不根据语言版切换的初始数据
      let list = [
        {
          image: require('@/assets/icons/ic_rectangle@2x.png'),
          type: 'qycg',
        },
        {
          image: require('@/assets/icons/ic_triangle@2x.png'),
          type: 'xmthz',
        },
        {
          image: require('@/assets/icons/ic_oval@2x.png'),
          type: 'fxhz',
        },
        {
          image: require('@/assets/icons/ic_polygon@2x.png'),
          type: 'schz',
        },
        {
          image: require('@/assets/icons/ic_rectangle@2x(1).png'),
          type: 'xxjghz',
        },
        {
          image: require('@/assets/icons/ic_semicircle@2x.png'),
          type: 'jxjghz',
        },
      ]
      // 结合语言版本进行初始化数据
      return listHandler.call(this, list, 'business.ways.list')
    },
  },
  methods: {
    closeThisDialog () {
      this.showDialog = false
    },
    showThisContrantWaay (type) {
      this.showContractInfo = this.contactWayMap[type]
      this.showDialog = true
    },
    jumpCooperate () {
      setTimeout(() => {
        document.body.querySelector('#cooperate').scrollIntoView({
          behavior: 'smooth',
        })
      }, 100)
    },
  },
  mounted () {
    setTitle(`${this.$t('home.logo')} - ${this.$t('home.navigation.bussiniss')}`)
    const fromJoinButton = this.$route.query.from
    if (!fromJoinButton) return
    this.jumpCooperate()
  },
}
</script>
<style lang='less' scoped>
</style>
